import React from 'react'
import { MotionButton, MotionCard, MotionImage, MotionSection } from '../motion/Motion'

const mats = [
  {
    id: 'large',
    line1: 'Large',
    line2: 'DoorMats',
    image: '/images/matts/large door matts.png',
    description:
      'Size matters, in the world of doormats, so if your space will accommodate it, a large door mat will encourage people to wipe their feet and protect more of your floor.',
  },
  {
    id: 'thin',
    line1: 'Thin',
    line2: 'DoorMats',
    image: '/images/matts/thin door matts.png',
    description:
      'Many modern doors run close to the floor. Good for energy efficiency, tricky for doormats. Our thin door mats are the answer.',
  },
  {
    id: 'washable',
    line1: 'Washable',
    line2: 'DoorMats',
    image: '/images/matts/washable door matts.png',
    description:
      "It's a door mat's job to get dirty. But you don't want the dirt to outstay its welcome. Our wide range of colourful washable door mats is a top choice.",
  },
  {
    id: 'heavy-duty',
    line1: 'Heavy Duty',
    line2: 'DoorMats',
    image: '/images/matts/heavy duty door matts.png',
    description:
      'Durable and dependable, protecting floors against the highest of traffic and muddiest of places. Our heavy duty door mats are extremely hard wearing.',
  },
]

export default function ShopByMatType() {
  return (
    <MotionSection className="w-full bg-[#ED3994] py-12 lg:py-16">
      <div className="w-[96%] mx-auto">
        <div className="text-center mb-8 lg:mb-10">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">
            Shop by Mat Type
          </h2>
          <p className="mt-2 text-sm sm:text-base text-gray-700 max-w-2xl mx-auto">
            Explore our most popular mat categories to match your entrance traffic, branding style, and maintenance needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 lg:gap-6">
          {mats.map((mat, index) => (
            <MotionCard
              key={mat.id}
              className="bg-white rounded-2xl overflow-hidden flex flex-col sm:flex-row items-stretch h-full w-full sm:w-[92%] mx-auto"
              delay={0.03 * index}
            >
              {/* Text side */}
              <div className="flex-1 px-5 sm:px-6 py-5 sm:py-6 flex flex-col justify-center gap-3">
                <div className="leading-tight">
                  <p className="text-base sm:text-lg font-semibold text-[#ED3994]">{mat.line1}</p>
                  <p className="text-base sm:text-lg font-semibold text-gray-900">{mat.line2}</p>
                </div>
                <p className="text-[13px] sm:text-sm text-gray-700 leading-relaxed max-w-xl">
                  {mat.description}
                </p>
                <button 
                  onClick={() => {
                    const phoneNumber = '27810634772'
                    const message = encodeURIComponent(`Hello! I would like to request a quote for ${mat.line1} ${mat.line2}.`)
                    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank')
                  }}
                  className="mt-1 inline-flex items-center justify-center rounded-full bg-[#ED3994] px-5 py-2 text-xs sm:text-sm font-semibold text-white hover:bg-pink-600 transition-colors w-fit"
                >
                  <MotionButton>Order Now!</MotionButton>
                </button>
              </div>

              {/* Image side */}
              <div className="sm:w-1/3 md:w-2/5 lg:w-1/3 flex items-start justify-end p-0">
                <MotionImage>
                  <img
                    src={mat.image}
                    alt={`${mat.line1} ${mat.line2}`}
                    className="max-h-32 sm:max-h-36 md:max-h-40 lg:max-h-40 w-auto object-contain"
                  />
                </MotionImage>
              </div>
            </MotionCard>
          ))}
        </div>
      </div>
    </MotionSection>
  )
}
